export const help = {
  title: 'Estamos para hablar, siempre',
  subtitle1: 'Será un gusto atenderte siempre.',
  subtitle2: 'Nuestros gurúes pueden ayudarte de lunes a viernes.',
  faqs: {
    title: 'Consulta nuestras preguntas frecuentes',
    button: 'Ver FAQs',
  },
  chat: {
    title: 'Chat disponible de 9hs-19hs',
    button: 'Abrir chat',
    error: 'En este momento no podemos atenderte.',
  },
  contact: {
    title: 'Escribinos y te contestaremos pronto',
    button: 'Contactar',
  },
}

export const faqCategories = {
  screenTitle: 'Ayuda',
  title: 'Consejos y respuestas de nuestros gurúes',
  button: 'Leer Faqs',
}

export const faqs = {
  screenTitle: 'Ayuda',
}

export const contact = {
  screenTitle: 'Ayuda',
  title: 'Escribinos',
  subtitle: 'Completa el formulario y responderemos lo antes posible. \nNo te olvides que también puedes chequear',
  faqsLink: 'nuestras faqs.',
  nameLabel: 'Nombre',
  emailLabel: 'Email',
  messageLabel: 'Mensaje',
  button: 'Enviar',
  sent: {
    title: '¡Tu mensaje ha sido enviado!',
    body: '¡Gracias por escribirnos! Pronto recibirás noticias nuestras. No te olvides que también puedes chequear',
    faqsLink: 'nuestras faqs.',
    button: 'Aceptar',
  }
}



// WEBPACK FOOTER //
// ./src/sections/help/text.js